module.exports = __webpack_public_path__ + "static/media/connectors_dark_mode.ff268075.png";